<template>
  <div class="elite-tabs-wrapper-content">
    <div class="custom-header">
      <h3>
        {{ `${user.firstname} ${user.lastname}` }} - {{ $t("COMMON.LOGS") }}
      </h3>
    </div>
    <log-list-table :filterSubject="user" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "user-view-authorizations",

  components: { LogListTable },

  props: ["user"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
